import React from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { AjaxLeadFormModel, GtmAnalyticsData, LinkModel, TrustedHtmlString } from '../../models/globals';
import { CtpContactUsButton } from '../enrollment/CtpContactUsButton';
import { EnrollNowButton } from '../enrollment/EnrollNowButton';

interface StickyBannerProps {
    addToCartGtmAnalyticsData: GtmAnalyticsData | undefined;
    addToCartLink: LinkModel;
    className?: string;
    height: number;
    isCtpOrCtpBundle: boolean;
    isConversionEnabled: boolean;
    name: TrustedHtmlString;
    leadFormModel: AjaxLeadFormModel;
}

const StickyBanner: React.FC<StickyBannerProps> = ({
    className = '',
    height,
    isCtpOrCtpBundle,
    isConversionEnabled,
    name,
    addToCartLink,
    addToCartGtmAnalyticsData,
    leadFormModel,
}) => {
    return (
        <Container
            className={`${className} bg-e2g_enrollment`.trim()}
            fluid
            style={{ height: height, marginTop: -height }}
        >
            <Container className="h-100">
                <Row className="h-100">
                    <Col className="align-self-center" md={8} lg={9}>
                        <h2 className="font-weight-normal text-white" dangerouslySetInnerHTML={{ __html: name }}></h2>
                    </Col>
                    <Col className="align-self-center">
                        <EnrollNowButton
                            addToCartGtmAnalyticsData={addToCartGtmAnalyticsData}
                            addToCartLink={addToCartLink}
                            className="mb-1 w-100"
                            showButton={isConversionEnabled}
                        />
                        {isCtpOrCtpBundle && (
                            <CtpContactUsButton className="mt-1 w-100" leadFormModel={leadFormModel} />
                        )}
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export { StickyBanner };
